export default {
  addOns: 'Adicionales',
  availability: 'Disponibilidad',
  availabilityDaySelector: 'Selector de fecha de disponibilidad',
  unavailable: 'No disponible',
  person: 'persona',
  people: 'personas',
  reserveNow: 'Reservar ahora',
  selectTime: 'Seleccionar hora',
  select: 'Seleccionar',
  reserve: 'Reservar',
  time: 'Hora',
  tier: 'Nivel',
  questions: 'Preguntas',
  addToCart: 'Añadir al carrito',
  checkout: 'Pagar',
  total: 'Total',
  whatsIncluded: 'Qué está incluido',
  showMore: 'Mostrar más',
  showLess: 'Mostrar menos',
  session: 'Sesión',
  viewDetails: 'Ver detalles',
  findAvailability: 'Encontrar disponibilidad',
  loading: 'Cargando',
  capacity: 'Capacidad',
  noAvailableSessionsOnThisDate: 'No hay sesiones disponibles en esta fecha',
  noGroupAvailableOnThisDateAndTime:
    'No hay {{groupTitle}} disponible en esta fecha y hora',
  noCollectionFound: 'No se encontró ninguna colección!',
  noResourceGroupFound: 'No se encontró ningún grupo de recursos!',
  noData: 'Sin datos!',
  continue: 'Continuar',
  night: 'noche',
  nights: 'noches',
  noAvailableSessionsForSelectedDates:
    'Algunas fechas en tu selección no tienen sesiones disponibles. Por favor selecciona fechas diferentes.',
  from: 'desde',
  dateRangeSelector: 'Selector de rango de fechas',
  priceTierRadioGroup: 'Selector de nivel de precio',
  startTime: 'Hora de inicio',
  duration: 'Duración',
  lengthOfStay: 'Duración de la estancia',
  startDate: 'Fecha de inicio',
  endDate: 'Fecha de fin',
  selectDates: 'Seleccionar fechas',
  more: 'Más',
  selectStartTime: 'Elige una hora de inicio',
  endTime: 'Hora de finalización',
  selectEndTime: 'Elige una hora de finalización',
  morning: 'Mañana',
  afternoon: 'Tarde',
  save: 'Guardar',
  selectDuration: 'Elige una duración',
  forLength: 'por {{length}}',
  moreDates: '{{count}} más',
  addDate: 'Añadir fecha',
  start: 'Inicio',
  end: 'Fin',
  pickupFrom: 'Recogida desde las',
  returnBy: 'Devolución antes de las',
  day: 'día',
  days: 'días',
  hour: 'hora',
  hours: 'horas',
};
